export class ResultsView {
  constructor(container, { onPlayAgain, onMainMenu, onLeaderboard, onRetrySave, onSignIn }) {
    this.container = container;
    this.onPlayAgain = onPlayAgain;
    this.onMainMenu = onMainMenu;
    this.onLeaderboard = onLeaderboard;
    this.onRetrySave = onRetrySave;
    this.onSignIn = onSignIn;

    this.element = null;
    this.scoreEl = null;
    this.distEl = null;
    this.orbEl = null;
    this.statusEl = null;
    this.retryBtn = null;
    this.signInBtn = null;

    this.init();
  }

  init() {
    this.element = document.createElement('div');
    this.element.className = 'ui-view results-view hidden modal-backdrop';

    const card = document.createElement('div');
    card.className = 'card-panel';
    card.style.maxWidth = '460px';
    card.style.width = '100%';
    card.style.textAlign = 'center';

    // Title
    const title = document.createElement('h2');
    title.className = 'text-heading';
    title.textContent = 'RUN OVER';
    title.style.color = 'var(--color-danger)';
    title.style.marginBottom = '16px';
    card.appendChild(title);

    // Score display
    const scoreBox = document.createElement('div');
    scoreBox.style.marginBottom = '20px';

    const scoreLabel = document.createElement('div');
    scoreLabel.className = 'text-muted';
    scoreLabel.style.fontSize = '0.9rem';
    scoreLabel.style.fontWeight = '700';
    scoreLabel.textContent = 'FINAL SCORE';

    this.scoreEl = document.createElement('div');
    this.scoreEl.className = 'tabular-num';
    this.scoreEl.style.fontSize = '3.5rem';
    this.scoreEl.style.fontWeight = '800';
    this.scoreEl.style.color = 'var(--color-primary)';
    this.scoreEl.textContent = '0';

    scoreBox.appendChild(scoreLabel);
    scoreBox.appendChild(this.scoreEl);
    card.appendChild(scoreBox);

    // Stats Grid
    const statsGrid = document.createElement('div');
    statsGrid.style.display = 'grid';
    statsGrid.style.gridTemplateColumns = '1fr 1fr';
    statsGrid.style.gap = '12px';
    statsGrid.style.marginBottom = '20px';

    // Distance Stat
    const distCard = document.createElement('div');
    distCard.style.background = 'var(--color-surface-raised)';
    distCard.style.padding = '12px';
    distCard.style.borderRadius = 'var(--radius-control)';
    const distTitle = document.createElement('div');
    distTitle.className = 'text-muted';
    distTitle.style.fontSize = '0.8rem';
    distTitle.textContent = 'DISTANCE';
    this.distEl = document.createElement('div');
    this.distEl.className = 'tabular-num';
    this.distEl.style.fontSize = '1.3rem';
    this.distEl.style.fontWeight = '700';
    this.distEl.textContent = '0m';
    distCard.appendChild(distTitle);
    distCard.appendChild(this.distEl);
    statsGrid.appendChild(distCard);

    // Orbs Stat
    const orbCard = document.createElement('div');
    orbCard.style.background = 'var(--color-surface-raised)';
    orbCard.style.padding = '12px';
    orbCard.style.borderRadius = 'var(--radius-control)';
    const orbTitle = document.createElement('div');
    orbTitle.className = 'text-muted';
    orbTitle.style.fontSize = '0.8rem';
    orbTitle.textContent = 'ENERGY ORBS';
    this.orbEl = document.createElement('div');
    this.orbEl.className = 'tabular-num';
    this.orbEl.style.fontSize = '1.3rem';
    this.orbEl.style.fontWeight = '700';
    this.orbEl.style.color = 'var(--color-collectible)';
    this.orbEl.textContent = '0';
    orbCard.appendChild(orbTitle);
    orbCard.appendChild(this.orbEl);
    statsGrid.appendChild(orbCard);

    card.appendChild(statsGrid);

    // Submission Status Banner
    this.statusEl = document.createElement('div');
    this.statusEl.style.padding = '10px 14px';
    this.statusEl.style.borderRadius = 'var(--radius-control)';
    this.statusEl.style.fontSize = '0.9rem';
    this.statusEl.style.fontWeight = '600';
    this.statusEl.style.marginBottom = '20px';
    this.statusEl.style.background = 'rgba(255, 255, 255, 0.05)';
    this.statusEl.textContent = 'Preparing results...';
    card.appendChild(this.statusEl);

    // Retry Button (Hidden by default)
    this.retryBtn = document.createElement('button');
    this.retryBtn.className = 'btn-secondary';
    this.retryBtn.style.width = '100%';
    this.retryBtn.style.marginBottom = '12px';
    this.retryBtn.style.display = 'none';
    this.retryBtn.textContent = '🔄 Retry Saving Score';
    this.retryBtn.onclick = () => this.onRetrySave();
    card.appendChild(this.retryBtn);

    // Guest Sign In Button (Hidden by default)
    this.signInBtn = document.createElement('button');
    this.signInBtn.className = 'btn-text';
    this.signInBtn.style.marginBottom = '12px';
    this.signInBtn.style.display = 'none';
    this.signInBtn.textContent = 'Sign in with Start.ng to submit scores';
    this.signInBtn.onclick = () => this.onSignIn();
    card.appendChild(this.signInBtn);

    // Primary Action: Play Again
    const playAgainBtn = document.createElement('button');
    playAgainBtn.className = 'btn-primary';
    playAgainBtn.style.width = '100%';
    playAgainBtn.style.padding = '14px';
    playAgainBtn.style.fontSize = '1.15rem';
    playAgainBtn.style.marginBottom = '10px';
    playAgainBtn.textContent = 'Play Again';
    playAgainBtn.onclick = () => this.onPlayAgain();
    card.appendChild(playAgainBtn);

    // Secondary Actions Row
    const actionRow = document.createElement('div');
    actionRow.style.display = 'grid';
    actionRow.style.gridTemplateColumns = '1fr 1fr';
    actionRow.style.gap = '10px';

    const menuBtn = document.createElement('button');
    menuBtn.className = 'btn-secondary';
    menuBtn.textContent = 'Main Menu';
    menuBtn.onclick = () => this.onMainMenu();
    actionRow.appendChild(menuBtn);

    const lbBtn = document.createElement('button');
    lbBtn.className = 'btn-secondary';
    lbBtn.textContent = 'Leaderboard';
    lbBtn.onclick = () => this.onLeaderboard();
    actionRow.appendChild(lbBtn);

    card.appendChild(actionRow);

    this.element.appendChild(card);
    this.container.appendChild(this.element);
  }

  setResults(summary) {
    this.scoreEl.textContent = String(summary.score || 0);
    this.distEl.textContent = `${summary.distance || 0}m`;
    this.orbEl.textContent = String(summary.orbs || 0);
    this.retryBtn.style.display = 'none';
    this.signInBtn.style.display = 'none';
  }

  setSubmissionState(state, message = '') {
    this.retryBtn.style.display = 'none';
    this.signInBtn.style.display = 'none';

    if (state === 'submitting') {
      this.statusEl.style.color = 'var(--color-primary)';
      this.statusEl.textContent = 'Saving score to Start.ng...';
    } else if (state === 'saved') {
      this.statusEl.style.color = 'var(--color-success)';
      this.statusEl.textContent = message || '✓ Score saved to Start.ng!';
    } else if (state === 'guest') {
      this.statusEl.style.color = 'var(--color-text-secondary)';
      this.statusEl.textContent = 'Guest Run — Sign in to submit to the leaderboard.';
      this.signInBtn.style.display = 'block';
    } else if (state === 'error') {
      this.statusEl.style.color = 'var(--color-danger)';
      this.statusEl.textContent = message || 'Score could not be saved.';
      this.retryBtn.style.display = 'block';
    }
  }

  show() {
    this.element.classList.remove('hidden');
  }

  hide() {
    this.element.classList.add('hidden');
  }
}
